/* eslint-disable @typescript-eslint/no-explicit-any */
import { Collection, CollectionQuery } from "../../../models/collection.model"
import { OwnerSetting } from "../../../models/owner-setting.model"
import { Owner } from "../../../models/owner.model"
import { Permission } from "../../../models/permission.model"
import { Role } from "../../../models/role.model"
import { notification } from "../../../shared/component/notification/utility/notification"
import { collectionQueryBuilder } from "../../../shared/utility/collection-builder/collection-query-builder"
import { appApi } from "../../../store/app.api"
import { USER_ENDPOINT } from "../../user/user.endpoint"
import { OWNER_ENDPOINT } from "../owner.endpoint"

let ownerCollection: CollectionQuery
let ownerCountCollection: CollectionQuery
let archivedOwnerCollection: CollectionQuery
const ownerQuery = appApi.injectEndpoints({
  endpoints: (builder) => ({
    getOwner: builder.query<Owner, string>({
      query: (id: string) => ({
        url: `${OWNER_ENDPOINT.detail}/${id}`,
        method: "get",
      }),
      providesTags: ["Owner"],

    }),

    getOwners: builder.query<Collection<Owner>, CollectionQuery>({
      query: (data: CollectionQuery) => ({
        url: `${OWNER_ENDPOINT.list}`,
        method: "GET",
        params: collectionQueryBuilder(data),
      }),
      providesTags: ["Owners"],
      async onQueryStarted(param, { queryFulfilled }) {
        try {
          const { data } = await queryFulfilled
          // if (data) {
          //   ownerCountCollection = param
          // }
        } catch (error: any) {
          notification(
            "error",
            error?.error?.data?.message
              ? error?.error?.data?.message
              : "Error try again",
          )
        }
      },
    }),
    getOwnerSettings: builder.query<OwnerSetting, string>({
      query: (ownerId: string) => ({
        url: `${OWNER_ENDPOINT.getSettings}/${ownerId}`,
        method: "GET",
        // params: collectionQueryBuilder(data),
      }),
      providesTags: ["Owner Settings"],
      async onQueryStarted(param, { queryFulfilled }) {
        try {
          const { data } = await queryFulfilled
          // if (data) {
          //   ownerCountCollection = param
          // }
        } catch (error: any) {
          notification(
            "error",
            error?.error?.data?.message
              ? error?.error?.data?.message
              : "Error try again",
          )
        }
      },
    }),
    countOwners: builder.query<any, CollectionQuery>({
      query: (data: CollectionQuery) => ({
        url: `${OWNER_ENDPOINT.list}`,
        method: "GET",
        params: collectionQueryBuilder(data),
      }),
      providesTags: ["Count Owners"],
      async onQueryStarted(param, { queryFulfilled }) {
        try {
          const { data } = await queryFulfilled
          // if (data) {
          //   ownerCollection = param
          // }
        } catch (error: any) {
          notification(
            "error",
            error?.error?.data?.message
              ? error?.error?.data?.message
              : "Error try again",
          )
        }
      },
    }),

    getArchivedOwner: builder.query<Owner, string>({
      query: (id: string) => ({
        url: `${OWNER_ENDPOINT.archivedOwner}/${id}`,
        method: "get",
      }),
      providesTags: ["Archived Owner"],
    }),

    getArchivedOwners: builder.query<Collection<Owner>, CollectionQuery>({
      query: (data: CollectionQuery) => ({
        url: `${OWNER_ENDPOINT.archivedOwners}`,
        method: "GET",
        params: collectionQueryBuilder(data),
      }),
      providesTags: ["Archived Owners"],
      async onQueryStarted(param, { queryFulfilled }) {
        try {
          const { data } = await queryFulfilled
          // if (data) {
          //   archivedOwnerCollection = param
          // }
        } catch (error: any) {
          notification(
            "error",
            error?.error?.data?.message
              ? error?.error?.data?.message
              : "Error try again",
          )
        }
      },
    }),

    createOwner: builder.mutation<Owner, Owner>({
      query: (newData: any) => ({
        url: `${OWNER_ENDPOINT.create}`,
        method: "post",
        data: newData,
        permissions: "manage-owners",
      }),
      invalidatesTags: ["Owners", "Count Owners"],
      async onQueryStarted(param, { dispatch, queryFulfilled }) {
        try {
          const { data } = await queryFulfilled
          if (data) {
            notification("success", "Successfully created")
          }
        } catch (error: any) {
          notification(
            "error",
            error?.error?.data?.message
              ? error?.error?.data?.message
              : "Error try again",
          )
        }
      },
    }),

    updateOwner: builder.mutation<Owner, Owner>({
      query: (newData: any) => ({
        url: `${OWNER_ENDPOINT.update}`,
        method: "put",
        data: newData,
        permission: "manage-owners",
      }),
      invalidatesTags: ["Owners", "Count Owners"],

      async onQueryStarted(param, { dispatch, queryFulfilled }) {
        try {
          const { data } = await queryFulfilled
          if (data) {
            notification("success", "Successfully updated")
            // dispatch(
            //   ownerQuery.util.updateQueryData(
            //     "getOwners",
            //     ownerCollection,
            //     (draft) => {
            //       if (data) {
            //         draft.data = draft?.data?.map((user) => {
            //           if (user.id === data.id) return data
            //           else {
            //             return user
            //           }
            //         })
            //       }
            //     },
            //   ),
            // )
          }
        } catch (error: any) {
          notification(
            "error",
            error?.error?.data?.message
              ? error?.error?.data?.message
              : "Error try again",
          )
        }
      },
    }),
    updateOwnerSetting: builder.mutation<OwnerSetting, OwnerSetting>({
      query: (newData: any) => ({
        url: `${OWNER_ENDPOINT.updateSettings}`,
        method: "put",
        data: newData,
        permission: "manage-owners",
      }),
      invalidatesTags: ["Owner Settings"],

      async onQueryStarted(param, { dispatch, queryFulfilled }) {
        try {
          const { data } = await queryFulfilled
          if (data) {
            notification("success", "Successfully updated")
            // dispatch(
            //   ownerQuery.util.updateQueryData(
            //     "getOwners",
            //     ownerCollection,
            //     (draft) => {
            //       if (data) {
            //         draft.data = draft?.data?.map((user) => {
            //           if (user.id === data.id) return data
            //           else {
            //             return user
            //           }
            //         })
            //       }
            //     },
            //   ),
            // )
          }
        } catch (error: any) {
          notification(
            "error",
            error?.error?.data?.message
              ? error?.error?.data?.message
              : "Error try again",
          )
        }
      },
    }),

    // updateUserProfile: builder.mutation<User, any>({
    //   query: (newData: any) => ({
    //     url: `${OWNER_ENDPOINT.updateProfile}` + newData.id,
    //     method: "post",
    //     data: newData.data,
    //   }),

    //   async onQueryStarted(param, { dispatch, queryFulfilled }) {
    //     try {
    //       const { data } = await queryFulfilled;
    //       if (data) {
    //         notification("success", "Successfully updated");
    //         dispatch(
    //           ownerQuery.util.updateQueryData(
    //             "getOwners",
    //             ownerCollection,
    //             (draft) => {
    //               if (data) {
    //                 draft.data = draft?.data?.map((user) => {
    //                   if (user.id === data.id) return data;
    //                   else {
    //                     return user;
    //                   }
    //                 });
    //               }
    //             }
    //           )
    //         );
    //       }
    //     } catch (error: any) {
    //       notification(
    //         "error",
    //         error?.error?.data?.message
    //           ? error?.error?.data?.message
    //           : "Error try again"
    //       );
    //     }
    //   },
    // }),

    toggleOwnerStatus: builder.mutation<Owner, string>({
      query: (id: string) => ({
        url: `${OWNER_ENDPOINT.toggleStatus}/${id}`,
        method: "post",
        permission: "manage-owners",
      }),
      invalidatesTags: ["Owners", "Owner", "Archived Owner", "Archived Owners", "Count Owners"],
      async onQueryStarted(param, { dispatch, queryFulfilled }) {
        try {
          const { data } = await queryFulfilled
          if (data) {
            notification("success", "Successfully updated status")
            // dispatch(
            //   ownerQuery.util.updateQueryData(
            //     "getOwners",
            //     ownerCollection,
            //     (draft) => {
            //       if (data) {
            //         draft.data = draft?.data?.map((owner: Owner) => {
            //           if (owner.id === data.id) return data
            //           else {
            //             return owner
            //           }
            //         })
            //       }
            //     },
            //   ),
            // )
            // dispatch(
            //   ownerQuery.util.updateQueryData("getOwner", param, (draft) => {
            //     draft.enabled = data.enabled
            //   }),
            // )
          }
        } catch (error: any) {
          notification(
            "error",
            error?.error?.data?.message ?? "Error try again",
          )
        }
      },
    }),
    bulkToggleOwnerStatus: builder.mutation<boolean, {ids: string[], enabled: boolean}>({
      query: (data: {ids: string[], enabled: boolean}) => ({
        url: `${OWNER_ENDPOINT.bulkToggleStatus}`,
        method: "post",
        permission: "manage-owners",
        data: data
      }),
      invalidatesTags: ["Owners", "Count Owners"],
      async onQueryStarted(param, { dispatch, queryFulfilled }) {
        try {
          const { data } = await queryFulfilled
          if (data) {
            notification("success", "Successfully updated status")
            // dispatch(
            //   ownerQuery.util.updateQueryData(
            //     "getOwners",
            //     ownerCollection,
            //     (draft) => {
            //       if (data) {
            //         draft.data = draft?.data?.map((owner: Owner) => {
            //           if (owner.id === data.id) return data
            //           else {
            //             return owner
            //           }
            //         })
            //       }
            //     },
            //   ),
            // )
            // dispatch(
            //   ownerQuery.util.updateQueryData("getOwner", param, (draft) => {
            //     draft.enabled = data.enabled
            //   }),
            // )
          }
        } catch (error: any) {
          notification(
            "error",
            error?.error?.data?.message ?? "Error try again",
          )
        }
      },
    }),

    archiveOwner: builder.mutation<Owner, { id: string; reason: string }>({
      query: (data) => ({
        url: `${OWNER_ENDPOINT.archive}`,
        method: "delete",
        data: data,
        permission: "manage-owners",
      }),
      invalidatesTags: ["Owners", "Owner", "Archived Owner", "Archived Owners", "Count Owners"],
      async onQueryStarted(arg, { dispatch, queryFulfilled }) {
        try {
          const { data } = await queryFulfilled
          if (data) {
            // dispatch(
            //   ownerQuery.util.updateQueryData(
            //     "getOwners",
            //     ownerCollection,
            //     (draft) => {
            //       draft.data = draft?.data?.map((provider) => {
            //         if (provider.id === arg.id) {
            //           return data
            //         } else {
            //           return provider
            //         }
            //       })
            //     },
            //   ),
            // )
            // dispatch(
            //   ownerQuery.util.updateQueryData("getOwner", arg?.id, (draft) => {
            //     draft.deletedAt = data?.deletedAt
            //   }),
            // )
            // dispatch(
            //   ownerQuery.util.updateQueryData(
            //     "getArchivedOwner",
            //     arg?.id,
            //     (draft) => {
            //       draft.deletedAt = data?.deletedAt
            //     },
            //   ),
            // )
            notification("success", "Successfully archived")
          }
        } catch (error: any) {
          notification(
            "error",
            error?.error?.data?.message ?? "Error try again",
          )
        }
      },
    }),

    deleteOwner: builder.mutation<boolean, string>({
      query: (id: string) => ({
        url: `${OWNER_ENDPOINT.delete}/${id}`,
        method: "delete",
        permission: "manage-owners",
      }),
      invalidatesTags: ["Owners", "Owner", "Archived Owner", "Archived Owners", "Count Owners"],
      async onQueryStarted(id, { dispatch, queryFulfilled }) {
        try {
          const { data } = await queryFulfilled
          if (data) {
            notification("success", "Successfully deleted")
            // dispatch(
            //   ownerQuery.util.updateQueryData(
            //     "getArchivedOwners",
            //     archivedOwnerCollection,
            //     (draft) => {
            //       if (data) {
            //         draft.data = draft.data.filter((user) => user.id !== id)
            //         draft.count -= 1
            //       }
            //     },
            //   ),
            // )
          }
        } catch (error: any) {
          notification(
            "error",
            error?.error?.data?.message ?? "Error try again",
          )
        }
      },
    }),

    restoreOwner: builder.mutation<Owner, string>({
      query: (id: string) => ({
        url: `${OWNER_ENDPOINT.restore}/${id}`,
        method: "post",
        permission: "manage-owners",
      }),
      invalidatesTags: ["Owners","Owner", "Archived Owner", "Archived Owners", "Count Owners"],
      async onQueryStarted(id, { dispatch, queryFulfilled }) {
        try {
          const { data } = await queryFulfilled
          if (data) {
            // dispatch(
            //   ownerQuery.util.updateQueryData(
            //     "getOwners",
            //     ownerCollection,
            //     (draft) => {
            //       draft.data = draft?.data?.map((provider) => {
            //         if (provider.id === id) {
            //           return data
            //         } else {
            //           return provider
            //         }
            //       })
            //     },
            //   ),
            // )
            // dispatch(
            //   ownerQuery.util.updateQueryData("getOwner", id, (draft) => {
            //     draft.deletedAt = data?.deletedAt
            //   }),
            // )
            // dispatch(
            //   ownerQuery.util.updateQueryData(
            //     "getArchivedOwner",
            //     id,
            //     (draft) => {
            //       draft.deletedAt = data?.deletedAt
            //     },
            //   ),
            // )
            notification("success", "Successfully restored")
          }
        } catch (error: any) {
          notification(
            "error",
            error?.error?.data?.message ?? "Error try again",
          )
        }
      },
    }),

    addAccountRolePermissions: builder.mutation<any, any>({
      query: (data: any) => ({
        url: `${USER_ENDPOINT.add_account_role_permission}`,
        method: "post",
        data: data,
      }),

      async onQueryStarted(param, { dispatch, queryFulfilled }) {
        try {
          const { data } = await queryFulfilled
          if (data) {
            dispatch(
              ownerQuery.util.updateQueryData(
                "getUserRolePermissions",
                { roleId: param.roleId, accountId: param.accountId },
                (draft) => {
                  if (data) {
                    draft = draft.concat(data)
                  }
                },
              ),
            )
            notification("success", "Permission Successfully assigned")
          }
        } catch (error: any) {
          notification(
            "error",
            error?.error?.data?.message
              ? error?.error?.data?.message
              : "Error try again",
          )
        }
      },
    }),

    addRoleToAccount: builder.mutation<Role[], any>({
      query: (data: any) => ({
        url: `${USER_ENDPOINT.add_account_role}`,
        method: "post",
        data: data,
      }),

      async onQueryStarted(param, { dispatch, queryFulfilled }) {
        try {
          const { data } = await queryFulfilled
          if (data) {
            dispatch(
              ownerQuery.util.updateQueryData(
                "getUserRoles",
                param.accountId,
                (draft) => {
                  if (data) {
                    draft.data = data
                    draft.count = data.length
                  }
                },
              ),
            )
            notification("success", "Successfully assigned")
          }
        } catch (error: any) {
          notification(
            "error",
            error?.error?.data?.message
              ? error?.error?.data?.message
              : "Error try again",
          )
        }
      },
    }),

    getRolePermissions: builder.query<Collection<Permission>, any>({
      query: (data: { roleId: string; collection: CollectionQuery }) => ({
        url: `${USER_ENDPOINT.role_permissions}/${data.roleId}`,
        method: "GET",
        params: collectionQueryBuilder(data.collection),
      }),
      async onQueryStarted(param, { queryFulfilled }) {
        try {
          // rolePermissionCollection = param
        } catch (error: any) {
          notification(
            "error",
            error?.error?.data?.message
              ? error?.error?.data?.message
              : "Error try again",
          )
        }
      },
    }),
    getUserRolePermissions: builder.query<Permission[], any>({
      query: (data: { roleId: string; accountId: string }) => ({
        url: `${USER_ENDPOINT.user_role_permissions}/${data.accountId}/${data.roleId}`,
        method: "GET",
      }),
      async onQueryStarted(param, { queryFulfilled }) {
        try {
          //
        } catch (error: any) {
          notification(
            "error",
            error?.error?.data?.message
              ? error?.error?.data?.message
              : "Error try again",
          )
        }
      },
    }),
    getUserRoles: builder.query<Collection<Role>, string>({
      query: (id: string) => ({
        url: `${USER_ENDPOINT.user_role}/${id}`,
        method: "GET",
      }),
      async onQueryStarted(param, { queryFulfilled }) {
        try {
        } catch (error: any) {
          notification(
            "error",
            error?.error?.data?.message
              ? error?.error?.data?.message
              : "Error try again",
          )
        }
      },
    }),
    getRoles: builder.query<Collection<Role>, CollectionQuery>({
      query: (data: CollectionQuery) => ({
        url: `${USER_ENDPOINT.roles}`,
        method: "GET",
        params: collectionQueryBuilder(data),
      }),
      async onQueryStarted(param, { queryFulfilled }) {
        try {
        } catch (error: any) {
          notification(
            "error",
            error?.error?.data?.message
              ? error?.error?.data?.message
              : "Error try again",
          )
        }
      },
    }),
    payForOwnerManually: builder.mutation<Owner, string>({
      query: (id: string) => ({
        url: `${OWNER_ENDPOINT.payForOwnerManually}`,
        method: "post",
        data: { ownerId: id },
        permission: "manage-owners",
      }),
      invalidatesTags: ["Owner", "Owners"],

      async onQueryStarted(id, { dispatch, queryFulfilled }) {
        try {
          const { data } = await queryFulfilled
          if (data) {
            // dispatch(
            //   leaseQuery.util.updateQueryData(
            //     "getLeases",
            //     leaseCollection,
            //     (draft) => {
            //       draft.data = draft?.data?.map((provider) => {
            //         if (provider.id === id) {
            //           return data
            //         } else {
            //           return provider
            //         }
            //       })
            //     },
            //   ),
            // )
            // dispatch(
            //   leaseQuery.util.updateQueryData("getLease", id, (draft) => {
            //     draft.deletedAt = data?.deletedAt
            //   }),
            // )

            notification("success", "Successfully Paid")
          }
        } catch (error: any) {
          notification(
            "error",
            error?.error?.data?.message ?? "Error try again",
          )
        }
      },
    }),
  }),

  overrideExisting: true,
})
export const {
  useLazyGetArchivedOwnerQuery,
  useLazyGetArchivedOwnersQuery,
  useLazyGetOwnerQuery,
  useLazyGetOwnerSettingsQuery,
  useLazyCountOwnersQuery,
  useLazyGetOwnersQuery,
  useCreateOwnerMutation,
  useDeleteOwnerMutation,
  useUpdateOwnerMutation,
  useArchiveOwnerMutation,
  useRestoreOwnerMutation,
  useToggleOwnerStatusMutation,

  useAddAccountRolePermissionsMutation,
  useAddRoleToAccountMutation,
  useLazyGetRolePermissionsQuery,
  useLazyGetUserRolePermissionsQuery,
  useLazyGetUserRolesQuery,
  useLazyGetRolesQuery,
  usePayForOwnerManuallyMutation,
  useBulkToggleOwnerStatusMutation,
  useUpdateOwnerSettingMutation
} = ownerQuery
